<template>
  <div class="complaintTypeConfig">
    <module-title :title="handleType ==='add' ? '添加投诉类型' : '编辑投诉类型'">
      <div class="right">
        <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="$emit('back')">
          返回上一页
        </el-button>
      </div>
    </module-title>
    <div class="addcommunity">
      <el-form
        ref="handleForm"
        :model="handleForm"
        :rules="handleRules"
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="投诉类型：" prop="typeName">
          <el-input
            v-model="handleForm.typeName"
            type="text"
            name="title"
            placeholder="请输入投诉类型名称"
            class="handle-form-input"
            show-word-limit
          />
        </el-form-item>
        <div v-for="(item,index) of handleForm.subtypeNames" :key="index">
          <el-form-item label="投诉名称：">
            <el-input
              v-model="item.name"
              type="text"
              name="title"
              placeholder="请输入投诉类型名称"
              class="handle-form-input"
              maxlength="20"
              show-word-limit
            />
            <span v-if="index>0" class="iconn-add-bnt" @click="delcommunityList(index)"> <i class="el-icon-delete-solid" /></span>
            <span v-if="index===handleForm.subtypeNames.length-1" class="iconn-add-bnt" @click="addcommunityList"> <i class="el-icon-circle-plus" /></span>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="dialog-footer">
      <el-button size="medium" @click="handleSearchReset">
        取消
      </el-button>
      <el-button type="primary" size="medium" @click="handleAddcommunity">
        保存
      </el-button>
    </div>
  </div>
</template>
<script>
import {
  type_complain_add,
  getSubTypes,
  updateComplaintName
} from '@/api/systemMaintenance/devicManage/wechatComplaint';
export default {
  name: 'CascaderConfigAdd',
  props: {
    handleType: {
      type: String,
      default: 'add'
    },
    updateRow: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    const validatorTypeName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('投诉类型不能为空'));
      } else if (value.length > 20) {
        callback(new Error('请输入20以内字符'));
      } else {
        callback();
      }
    };
    return {
      handleForm: {
        typeName: '',
        subtypeNames: [{ name: '' }]
      },
      handleRules: {
        typeName: [{ required: true, trigger: 'blur', validator: validatorTypeName }]
      }
    };
  },
  mounted() {
    console.log(this.updateRow);
    if (this.handleType !== 'add') {
      this.handleForm.typeName = this.updateRow.typeName;
      this.fetchdataList();
    }
  },
  methods: {
    // 获取应用列表
    fetchdataList() {
      this.listLoading = true;
      getSubTypes(this.updateRow.id)
        .then(result => {
          if (result.data) {
            result.data.map(item => {
              item.name = item.typeName;
            });
            this.handleForm.subtypeNames = result.data;
          } else {
            this.handleForm.subtypeNames = [];
          }
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.listLoading = false;
          this.dataList = [];
        });
    },
    // 删除
    delcommunityList(num) {
      this.handleForm.subtypeNames.splice(num, 1);
    },
    // 添加
    addcommunityList() {
      this.handleForm.subtypeNames.push({ name: '' });
    },
    handleSearchReset() {
      this.handleForm = {
        typeName: '',
        subtypeNames: [{ name: '' }]
      };
    },
    // 保存
    handleAddcommunity() {
      this.$refs['handleForm'].validate(valid => {
        if (valid) {
          var subtypeNames = [];
          this.handleForm.subtypeNames.forEach(item => {
            subtypeNames.push(item.name);
          });
          var op = {
            typeName: this.handleForm.typeName,
            subtypeNames: subtypeNames
          };
          if (this.handleType === 'add') {
            type_complain_add(op)
              .then(res => {
                this.$notify.success({
                  title: 'Success',
                  message: `添加投诉类型成功`,
                  showClose: false,
                  duration: 2000
                });
                this.$emit('back');
              });
          } else {
            updateComplaintName(op)
              .then(res => {
                this.$notify.success({
                  title: 'Success',
                  message: `修改投诉类型成功`,
                  showClose: false,
                  duration: 2000
                });
                this.$emit('back');
              });
          }
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.addcommunity {
  padding-bottom: 20px;
  .handle-form-input {
    width: 80%;
  }
  .handle-form-input1{
    width: 50%;
  }
  .subItem{ margin-left: 40px; }
  .iconn-add-bnt{
    font-size: 22px;
    margin-left: 10px;
    line-height: 36px;
  }
}
.dialog-footer{text-align: center;margin-top: 20px;}
</style>
